/**
 * Ponto de entrada da geração de documento da proposta solar.
 *
 * FONTE ÚNICA compartilhada por:
 * - src/components/CalculadoraSolar.js (botão GERAR)
 * - src/components/ConsultaPropostas.js (botão PDF da listagem)
 *
 * Qualquer alteração de layout, cálculo, template PPTX, PDF HangSix ou PDF Amazon Energy
 * deve ser feita neste módulo (hangSixPropostaHtml.js / amazonEnergyPropostaHtml.js).
 * NÃO copie a lógica de volta para os componentes.
 */

import { isAmazonEnergy, isHangSix, usaFluxoPptx } from './constantes'
import { gerarPropostaPPTX } from './gerarPptx'
import { gerarPdfAmazon } from './gerarPdfAmazon'
import { gerarPdfHangSix } from './gerarPdfHangSix'
import { gerarPdfPadrao } from './gerarPdfPadrao'

export {
  EMPRESA_AMAZON_ENERGY_ID,
  EMPRESA_CLAREAR_ID,
  EMPRESA_LXP_ID,
  EMPRESA_HANGSIX_ID,
  isAmazonEnergy,
  isHangSix,
  isClarear,
  isLxp,
  usaFluxoPptx
} from './constantes'

export {
  montarDadosDocumentoCalculadora,
  montarDadosDocumentoPropostaSalva
} from './mapearDados'

export { gerarPropostaPPTX } from './gerarPptx'
export { gerarPdfAmazon } from './gerarPdfAmazon'
export { gerarPdfHangSix } from './gerarPdfHangSix'
export { gerarPdfPadrao } from './gerarPdfPadrao'

/**
 * Gera o PDF da proposta (HangSix HTML, Amazon Energy HTML ou PDF padrão jsPDF)
 * e também o arquivo .html correspondente.
 * @param {{ dados: object, userEmpresa: object }} args
 */
export async function gerarPDFProposta({ dados, userEmpresa }) {
  if (isHangSix(userEmpresa?.id)) {
    return gerarPdfHangSix({ dados, userEmpresa })
  }
  if (isAmazonEnergy(userEmpresa?.id)) {
    return gerarPdfAmazon({ dados, userEmpresa })
  }
  return gerarPdfPadrao({ dados, userEmpresa })
}

/**
 * Mesma regra do botão GERAR da Calculadora Solar:
 * Clarear/LXP → PPTX; HangSix → PDF HTML; Amazon Energy → PDF HTML; demais → PDF padrão.
 * @param {{ dados: object, userEmpresa: object }} args
 */
export async function gerarDocumentoPropostaSolar({ dados, userEmpresa }) {
  if (usaFluxoPptx(userEmpresa?.id)) {
    return gerarPropostaPPTX({ dados, userEmpresa })
  }
  return gerarPDFProposta({ dados, userEmpresa })
}
